/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const pwa = {
  pwa: {
    addToHomeScreenDescription:
      'Add L&M Pumps to your device homescreen for a faster return visit',
    noInstallationNeeded: 'No installation needed',
    fastAccessToApplication: 'Fast access to application',
    addToHomeScreen: 'Add to home screen',
    addedToHomeScreen: 'L&M Pumps was added to your home screen',
  },
};
